<template>
	<div class="p-8" id="form_pdf">
		<student-assement-form :formData="formData"></student-assement-form>
	</div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import StudentAssementForm from '@/views/record/studentDetail/features/result/StudentAssementForm.vue';
import { useRoute } from 'vue-router';
import { useStudent } from '@/features/student/useStudent';

const route = useRoute();
const formData = ref({});
const id = computed(() => Number(route.params.id));
const formId = computed(() => Number(route.query.formId));
const student = ref(null);

onMounted(() => {
	fetchStudent();
	fetchResultDetail();
});

async function fetchStudent() {
	const response = await fetch(
		process.env.VUE_APP_BASE_URL + `v1/staff/students/${id.value}`,
		{
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				'x-access-token': route?.query?.token,
				'x-subdomain': route?.query?.subdomain,
			},
		}
	);
	const data = await response.json();
	student.value = data.data;
}

async function fetchResultDetail() {
	try {
		const response = await fetch(
			process.env.VUE_APP_BASE_URL +
				`v1/staff/students/${id.value}/student_assessment_forms/${formId.value}`,
			{
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
					'x-access-token': route?.query?.token,
					'x-subdomain': route?.query?.subdomain,
				},
			}
		);
		const data = await response.json();
		formData.value = data;
	} catch (e) {
		await this.$store.dispatch('setAlertMessage', {
			message: 'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	} finally {
		if (route?.query?.is_print === 'true') {
			setTimeout(() => {
				window.print();
			}, 3000);
		}
	}
}
</script>
